export enum AccessSectionEnum {
  Contacts = 1,
  ContactGroups = 2,
  ContactEvents = 3,
  BulkSend = 100,
  MobileBankSend = 101,
  ParametricSend = 102,
  MultipleTextSend = 103,
  ScheduledCampaign = 104,
  ABTestCampaign = 105,
  EventCampaign = 106,
  ReceivedMessagesReport = 107,
  UserTemplate = 108,
  BlackListInquiryCount = 109,
  SaleCooperation = 110,
  PersonalBlackListKeyword = 111,
  FastSend = 112,
  ApiKey = 113,
  IPLimitationOnApiKeys = 114,
  SmsTransmission = 115,
  SmsTransmissionApiParameterless = 116,
  SmsTransmissionApiWithParameter = 117,
  SmsTransmissionEmailParameterless = 118,
  SmsTransmissionEmailWithParameter = 119,
  SmsTransmissionMobileParameterless = 120,
  SmsTransmissionMobileWithParameter = 121,
  SmsSecretary = 122,
  SmsSecretaryParameterless = 123,
  SmsSecretaryWithParameter = 124,
  CodeReader = 125,
  CodeReaderParameters = 126,
  SmartZoneSend  = 127,
  WebServices = 128,
  PayamakSefid = 129,
  PayamakSefidContactsCount = 130,
  XMAAI = 131,
  BuyCredit = 133,
  BuyLine = 134,
  BuyPlan = 135,
  BuySmartZoneSend = 136,
  MessengerSend = 137,
  WorkspaceMembers = 138,
  JoinedWorkspaces = 139,
}
